"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.investmentsQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 * @hidden
 *
 * Get all investments for a given offering
 */
function investmentsQuery(paddedIds, filters, size, start) {
    const orderBy = paddedIds
        ? `${types_1.InvestmentsOrderBy.CreatedBlockIdAsc}`
        : `${types_1.InvestmentsOrderBy.CreatedAtAsc}, ${types_1.InvestmentsOrderBy.CreatedBlockIdAsc}`;
    const query = (0, graphql_tag_1.default) `
    query InvestmentsQuery($stoId: Int!, $offeringToken: String!, $size: Int, $start: Int) {
      investments(
        filter: { stoId: { equalTo: $stoId }, offeringToken: { equalTo: $offeringToken } }
        first: $size
        offset: $start
        orderBy: [${orderBy}]
      ) {
        totalCount
        nodes {
          investorId
          offeringToken
          raiseToken
          offeringTokenAmount
          raiseTokenAmount
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.investmentsQuery = investmentsQuery;
//# sourceMappingURL=stos.js.map